import { useState, useEffect, useCallback } from "react"
import axios from "axios"
import { PiSortAscendingLight, PiSortDescendingLight } from "react-icons/pi"
import { RiDeleteBin5Line } from "react-icons/ri"
import { BiSolidEdit } from "react-icons/bi"
import { IoMdAddCircleOutline } from "react-icons/io";
import { FaCopy, FaFileCsv, FaFileExcel, FaFilePdf } from "react-icons/fa";
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


import { jsPDF } from "jspdf";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import "jspdf-autotable";
import { saveAs } from "file-saver";
import { BaseUrl } from "../App"
function Register() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false)
  const [deleteId, setDeleteId] = useState(null)
  const [activeTab, setActiveTab] = useState("email")
  const [tableData, setTableData] = useState([])
  const [sortedTable, setSortedTable] = useState([])
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" })
  const [successMessage, setSuccessMessage] = useState(false)
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); 
  const [formData, setFormData] = useState({
    id: null,
    fname: "",
    lname: "",
    email: "",
    password: "",
    contactNumber: "",
    streetAddress: "",
    zipCode: "",
    city: "",
    state: "",
  })
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  const [entriesPerPage, setEntriesPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [error, setError] = useState(null)
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);
  const handleSort = (column) => {
    let direction = "asc"
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc"
    }
    setSortConfig({ key: column, direction })

    const sortedData = [...tableData].sort((a, b) => {
      if (a[column] < b[column]) return direction === "asc" ? -1 : 1
      if (a[column] > b[column]) return direction === "asc" ? 1 : -1
      return 0
    })

    setSortedTable(sortedData)
  }
  const handleAllMessagesClick = () => {
    navigate("emlsms"); // Navigate to the "All messages" route
  };

  const getSortIcon = (column) => {
    if (sortConfig.key !== column) {
      return <PiSortAscendingLight className="text-gray-500" />
    }
    return sortConfig.direction === "asc" ? <PiSortAscendingLight /> : <PiSortDescendingLight />
  }

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
    if (!isSidebarOpen) {
      setFormData({
        id: null,
        fname: "",
        lname: "",
        email: "",
        password: "",
        contactNumber: "",
        streetAddress: "",
        zipCode: "",
        city: "",
        state: "",
      })
    }
  }

  const handleSearch = (e) => setSearchQuery(e.target.value)

  const handleEntriesChange = (e) => {
    const value = e.target.value
    setEntriesPerPage(value === "All" ? "All" : Number.parseInt(value, 10))
    setCurrentPage(1)
  }

  const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1))
  const handleNextPage = () => setCurrentPage((prev) => prev + 1)
  const handlePageChange = (page) => setCurrentPage(page)

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null)
    try {
      const response = await axios.get(`${BaseUrl}/backend/api/add_customer.php`, {
        params: {
          action: "get_customers",
          api_key: "1", // Replace with actual API key
          page: currentPage,
          limit: entriesPerPage === "All" ? 1000 : entriesPerPage,
        },
      })

      if (response.data.status === "true") {
        const formattedData = response.data.customers.map((customer) => ({
          id: customer.id,
          name: `${customer.first_name} ${customer.last_name}`,
          email: customer.email,
          mobile: customer.phone,
          password: customer.password,
          address: customer.address,
          Zip_code: customer.zip,
          city: customer.city,
          State: customer.state,
          cus_dt: customer.cus_dt,
        }))
        setTableData(formattedData)
        setSortedTable(formattedData)
      } else {
        setError(response.data.response || "Error fetching data")
      }
    } catch (error) {
      setError("Error fetching data: " + error.message)
    }
    finally {
      setLoading(false);
    }
  }, [currentPage, entriesPerPage])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const addCustomer = async (customerData) => {
    setLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/add_customer.php`, {
        action: "add_customer",
        api_key: "1",
        ...customerData,
      })

      if (response.data.status === "true") {
        setSuccessMessage("Add Customer Successfully!")
        fetchData()
        toggleSidebar()
        resetFormData()
      } else {
        alert(response.data.response)
      }
    } catch (error) {
      console.error("Error occurred while adding customer:", error)
      alert("There was an error adding the customer. Please try again.")
    }
    finally {
      setLoading(false);
    }
  }

  const editCustomer = async (customerData) => {
    setLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/add_customer.php`, {
        action: "edit_customer",
        api_key: "1",
        ...customerData,
      })

      if (response.data.status === "true") {
        setSuccessMessage("Edit Customer Successfully!")
        fetchData()
        toggleSidebar()
        resetFormData()
      } else {
        alert(response.data.response)
      }
    } catch (error) {
      console.error("Error occurred while editing customer:", error)
      alert("There was an error updating the customer. Please try again.")
    }
    finally {
      setLoading(false);
    }
  }

  const resetFormData = () => {
    setFormData({
      id: null,
      fname: "",
      lname: "",
      email: "",
      password: "",
      contactNumber: "",
      streetAddress: "",
      zipCode: "",
      city: "",
      state: "",
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true);
    const customerData = {
      id: formData.id,
      email: formData.email,
      password: formData.password,
      first_name: formData.fname,
      last_name: formData.lname,
      phone: formData.contactNumber,
      address: formData.streetAddress,
      zipcode: formData.zipCode,
      city: formData.city,
      state: formData.state,
    }

    if (formData.id) {
      await editCustomer(customerData)
    } else {
      await addCustomer(customerData)
    }
  }

  const handleDelete = (id) => {
    setDeleteId(id)
    setIsDeleteConfirmOpen(true)
  }

  const handleEdit = (id) => {
    const row = tableData.find((row) => row.id === id)
    setFormData({
      id: row.id,
      fname: row.name.split(" ")[0],
      lname: row.name.split(" ")[1] || "",
      email: row.email,
      password: row.password,
      contactNumber: row.mobile,
      streetAddress: row.address,
      zipCode: row.Zip_code,
      city: row.city,
      state: row.State,
    })
    setIsSidebarOpen(true)
  }

  const confirmDelete = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/add_customer.php`, {
        action: "delete_customer",
        api_key: "1",
        id: deleteId,
      })

      if (response.data.status === "true") {
        setSuccessMessage("Delete Customer Successfully!")
        setTableData(tableData.filter((row) => row.id !== deleteId))
        setIsDeleteConfirmOpen(false)
        fetchData()
      } else {
        alert(response.data.response)
      }
    } catch (error) {
      console.error("Error occurred while deleting:", error)
      alert("There was an error deleting the customer. Please try again.")
    }
    finally {
      setLoading(false);
    }
  }

  const cancelDelete = () => setIsDeleteConfirmOpen(false)

  const handleCsvExport = () => {
    const csvData = tableData.map((row) => Object.values(row).join(","))
    const csvContent = `data:text/csv;charset=utf-8,${csvData.join("\n")}`
    const encodedUri = encodeURI(csvContent)
    const link = document.createElement("a")
    link.setAttribute("href", encodedUri)
    link.setAttribute("download", "CustomerData.csv")
    link.click()
  }

  const handleExcelExport = () => {
    const ws = XLSX.utils.json_to_sheet(tableData)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1")
    const excelFile = XLSX.write(wb, { bookType: "xlsx", type: "array" })
    saveAs(new Blob([excelFile], { type: "application/octet-stream" }), "CustomerData.xlsx")
  }

  const handlePdfExport = () => {
    const doc = new jsPDF()
    doc.setFontSize(16)
    doc.text("Customer Table Data", 10, 10)
    const tableHeaders = ["ID", "First Name", "Last Name", "Email", "Address", "City", "Phone", "State", "Zip"]
    const tableRows = tableData.map((row) => [
      row.id,
      row.name.split(" ")[0],
      row.name.split(" ")[1] || "",
      row.email,
      row.address,
      row.city,
      row.mobile,
      row.State,
      row.Zip_code,
    ])
    doc.autoTable({
      head: [tableHeaders],
      body: tableRows,
      startY: 20,
      theme: "striped",
    })
    doc.save("CustomerData.pdf")
  }

  const handleCopy = () => {
    // Collect the data from the table
    const tableContent = tableData
      .map((row) => {
        return [
          row.id,
          row.name.split(" ")[0],
          row.name.split(" ")[1] || "",
          row.email,
          row.address,
          row.city,
          row.mobile,
          row.State,
          row.Zip_code,
        ];
      })
      .join("\n");  // Join each row with a newline for better readability
  
    // Check if Clipboard API is supported
    if (navigator?.clipboard) {
      // Use Clipboard API if available
      navigator.clipboard.writeText(tableContent)
        .then(() => {
          alert("Table data copied to clipboard!");
        })
        .catch((error) => {
          console.error("Error copying to clipboard: ", error);
          alert("Failed to copy data. Please try again.");
        });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = tableContent;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        alert("Table data copied to clipboard!");
      } catch (err) {
        console.error("Error using execCommand: ", err);
        alert("Failed to copy data. Please try again.");
      }
      document.body.removeChild(textArea);  // Remove the textarea after copying
    }
  };

  const filteredData = sortedTable.filter(
    (row) =>
      row.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      row.email.toLowerCase().includes(searchQuery.toLowerCase()),
  )

  const startIndex = (currentPage - 1) * (entriesPerPage === "All" ? filteredData.length : entriesPerPage)
  const paginatedData =
    entriesPerPage === "All"
      ? filteredData
      : filteredData.slice(startIndex, startIndex + Number.parseInt(entriesPerPage, 10))
  const totalPages = Math.ceil(filteredData.length / (entriesPerPage === "All" ? filteredData.length : entriesPerPage))
  
  const handleEditClick = (id) => {
    navigate(`/admin/editCustomer/${id}`);
  };
  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         

    <div className="container mx-auto px-4 md:px-6 lg:px-8  xl:px-24 py-6 ">
     {successMessage && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{successMessage}</span>
        </div>
      )}

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{error}</span>
        </div>
      )}

      <div
        className={`fixed inset-y-0 right-0 w-full max-w-sm bg-white shadow-lg z-50 transform ${isSidebarOpen ? "translate-x-0" : "translate-x-full"} transition-all duration-500 ease-in-out md:max-w-md`}
      >
        <div className="p-4 flex justify-between items-center bg-blue-500 text-white">
          <h2 className="text-lg font-semibold">{formData.id ? "Edit Entry" : "Add Customer"}</h2>
          <button onClick={toggleSidebar} className="text-2xl font-bold">
            &times;
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-full">
          {successMessage && (
            <div className="mb-4 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded text-center">
              Your entry has been successfully {formData.id ? "updated" : "added"}!
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="ml-1">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Valid Email Address*"
                className="w-full mt-2 p-3 border border-gray-300 rounded-lg"
                required
              />
            </div>
            <div className="mb-4">
              <label className="ml-1">Password</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="min 8 characters*"
                className="w-full mt-2 p-3 border border-gray-300 rounded-lg"
                required={!formData.id}
              />
            </div>
            <div className="mb-4">
              <label className="ml-1">First Name</label>
              <input
                type="text"
                name="fname"
                value={formData.fname}
                onChange={handleChange}
                placeholder="First Name*"
                className="w-full mt-2 p-3 border border-gray-300 rounded-lg"
                required
              />
            </div>
            <div className="mb-4">
              <label className="ml-1">Last Name</label>
              <input
                type="text"
                name="lname"
                value={formData.lname}
                onChange={handleChange}
                placeholder="Last Name*"
                className="w-full mt-2 p-3 border border-gray-300 rounded-lg"
                required
              />
            </div>
            <div className="mb-4">
              <label className="ml-1">Phone No.</label>
              <input
                type="text"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleChange}
                placeholder="Contact Number* (e.g., 9876......)"
                className="w-full mt-2 p-3 border border-gray-300 rounded-lg"
                pattern="^\d{10}$"
                title="Contact number must be 10 digits"
                required
              />
            </div>
            <div className="mb-4">
              <label className="ml-1">Street Address</label>
              <input
                type="text"
                name="streetAddress"
                value={formData.streetAddress}
                onChange={handleChange}
                placeholder="Street Address* (e.g., 123 Main St)"
                className="w-full mt-2 p-3 border border-gray-300 rounded-lg"
                required
              />
            </div>
            <div className="mb-4">
              <label className="ml-1">Zip Code</label>
              <input
                type="text"
                name="zipCode"
                value={formData.zipCode}
                onChange={handleChange}
                placeholder="Zip Code* (e.g., 123456)"
                className="w-full mt-2 p-3 border border-gray-300 rounded-lg"
                pattern="^\d{6}$"
                title="Zip code must be 6 digits"
                required
              />
            </div>
            <div className="mb-4">
              <label className="ml-1">City</label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="City* (e.g., New York)"
                className="w-full mt-2 p-3 border border-gray-300 rounded-lg"
                required
              />
            </div>
            <div className="mb-4">
              <label className="ml-1">State</label>
              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                placeholder="State* (e.g., California)"
                className="w-full mt-2 p-3 border border-gray-300 rounded-lg"
                required
              />
            </div>
            <button
              type="submit"
              className="w-full mt-4 mb-9 p-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
            >
              {formData.id ? "Update Entry" : "Submit"}
            </button>
          </form>
        </div>
      </div>

      {isSidebarOpen && <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-40" onClick={toggleSidebar}></div>}

      {isDeleteConfirmOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
            <h3 className="text-xl font-semibold mb-4">Are you sure you want to delete this entry?</h3>
            <div className="flex justify-end space-x-4">
              <button onClick={confirmDelete} className="bg-red-500 text-white px-4 py-2 rounded-lg">
                Yes
              </button>
              <button onClick={cancelDelete} className="bg-gray-500 text-white px-4 py-2 rounded-lg">
                No
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="text-2xl font-bold p-4">
        <span>Registered Customers</span>
      </div>

      <div className="flex flex-col gap-4 mb-4">
        <input
          type="text"
          placeholder="Search customer..."
          value={searchQuery}
          onChange={handleSearch}
          className="p-2 w-full rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
        />

        <div className="flex flex-wrap justify-center gap-2">
          <button
            onClick={handleCopy}
            className="bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold py-2 px-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2"
          >
            <FaCopy className="text-xl" />
            <span className="text-sm">Copy</span>
          </button>
          <button
            onClick={handleCsvExport}
            className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-white font-semibold py-2 px-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2"
          >
            <FaFileCsv className="text-xl" />
            <span className="text-sm">CSV</span>
          </button>
          <button
            onClick={handleExcelExport}
            className="bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold py-2 px-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2"
          >
            <FaFileExcel className="text-xl" />
            <span className="text-sm">Excel</span>
          </button>
          <button
            onClick={handlePdfExport}
            className="bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold py-2 px-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2"
          >
            <FaFilePdf className="text-xl" />
            <span className="text-sm">PDF</span>
          </button>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-sm">Show</span>
            <select
              value={entriesPerPage}
              onChange={handleEntriesChange}
              className="p-1 text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value="All">All</option>
            </select>
            <span className="text-sm">entries</span>
          </div>

          <button
            onClick={toggleSidebar}
            className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold py-2 px-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2"
          >
            <IoMdAddCircleOutline className="text-xl" />
            <span className="text-sm">Add</span>
          </button>
        </div>
      </div>

      <div className="overflow-x-auto">
        {error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <>
            {/* Table view for larger screens */}
            <div className="hidden md:block">
              <table className="min-w-full table-auto bg-white border border-gray-300 shadow-md rounded-lg">
                <thead className="bg-blue-100 text-left">
                  <tr>
                    <th className="px-4 py-2 border-b cursor-pointer">#</th>
                    <th className="px-4 py-2 border-b cursor-pointer" onClick={() => handleSort("name")}>
                      <div className="flex items-center gap-2">Customer Name {getSortIcon("name")}</div>
                    </th>
                    <th className="px-4 py-2 border-b cursor-pointer" onClick={() => handleSort("email")}>
                      <div className="flex items-center gap-2">Email Address {getSortIcon("email")}</div>
                    </th>
                    <th className="px-4 py-2 border-b cursor-pointer" onClick={() => handleSort("mobile")}>
                      <div className="flex items-center gap-2">Mobile No. {getSortIcon("mobile")}</div>
                    </th>
                    <th className="px-4 py-2 border-b cursor-pointer" onClick={() => handleSort("Zip_code")}>
                      <div className="flex items-center gap-2">Zip Code {getSortIcon("Zip_code")}</div>
                    </th>
                    <th className="px-4 py-2 border-b cursor-pointer" onClick={() => handleSort("city")}>
                      <div className="flex items-center gap-2">City {getSortIcon("city")}</div>
                    </th>
                    <th className="px-4 py-2 border-b cursor-pointer" onClick={() => handleSort("State")}>
                      <div className="flex items-center gap-2">State {getSortIcon("State")}</div>
                    </th>
                    <th className="px-4 py-2 border-b cursor-pointer" onClick={() => handleSort("cus_dt")}>
                      <div className="flex items-center gap-2">Date & Time {getSortIcon("cus_dt")}</div>
                    </th>
                    <th className="px-4 py-2 border-b">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.map((row, index) => (
                    <tr key={row.id} className="hover:bg-gray-50">
                      <td className="px-4 py-2 border-b">{startIndex + index + 1}</td>
                      <td className="px-4 py-2 border-b">{row.name}</td>
                      <td className="px-4 py-2 border-b">{row.email}</td>
                      <td className="px-4 py-2 border-b">{row.mobile}</td>
                      <td className="px-4 py-2 border-b">{row.Zip_code}</td>
                      <td className="px-4 py-2 border-b">{row.city}</td>
                      <td className="px-4 py-2 border-b">{row.State}</td>
                      <td className="px-4 py-2 border-b">{row.cus_dt}</td>
                      <td className="px-4 py-2 border-b">
                        <button onClick={() => handleEditClick(row.id)} className="text-green-700 hover:text-green-900 mr-2">
                          <BiSolidEdit className="text-2xl" />
                        </button>
                        <button onClick={() => handleDelete(row.id)} className="text-red-500 hover:text-red-600">
                          <RiDeleteBin5Line className="text-2xl" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Card view for mobile */}
            <div className="grid grid-cols-1 gap-4 md:hidden">
              {paginatedData.map((row, index) => (
                <div key={row.id} className="bg-white p-3 rounded-lg shadow-md border border-gray-200">
                  <div className="flex justify-between items-center mb-2">
                    <h3 className="font-bold text-lg">{row.name}</h3>
                    <div className="flex space-x-2">
                      <button onClick={() => handleEdit(row.id)} className="text-green-700 hover:text-green-900">
                        <BiSolidEdit className="text-xl" />
                      </button>
                      <button onClick={() => handleDelete(row.id)} className="text-red-500 hover:text-red-600">
                        <RiDeleteBin5Line className="text-xl" />
                      </button>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-1 text-sm">
                    <p className="text-gray-600">Email:</p>
                    <p className="font-medium">{row.email}</p>
                    <p className="text-gray-600">Mobile:</p>
                    <p className="font-medium">{row.mobile}</p>
                    <p className="text-gray-600">Zip Code:</p>
                    <p className="font-medium">{row.Zip_code}</p>
                    <p className="text-gray-600">City:</p>
                    <p className="font-medium">{row.city}</p>
                    <p className="text-gray-600">State:</p>
                    <p className="font-medium">{row.State}</p>
                    <p className="text-gray-600">Date & Time:</p>
                    <p className="font-medium">{row.cus_dt}</p>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      <div className="flex flex-col items-center gap-4 mt-4">
        <div className="text-sm text-gray-600 text-center">
          Showing {startIndex + 1} to {Math.min(startIndex + paginatedData.length, filteredData.length)} of{" "}
          {filteredData.length} entries
        </div>

        {entriesPerPage !== "All" && (
          <div className="flex items-center">
            <button
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              className="px-2 py-1 text-sm bg-gray-200 rounded-l hover:bg-gray-300 disabled:opacity-50"
            >
              Prev
            </button>
            {[...Array(totalPages).keys()].map((page) => (
              <button
                key={page + 1}
                onClick={() => handlePageChange(page + 1)}
                className={`px-2 py-1 text-sm border ${
                  currentPage === page + 1 ? "bg-blue-500 text-white" : "bg-gray-200 hover:bg-gray-300"
                }`}
              >
                {page + 1}
              </button>
            ))}
            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className="px-2 py-1 text-sm bg-gray-200 rounded-r hover:bg-gray-300 disabled:opacity-50"
            >
              Next
            </button>
          </div>
        )}
      </div>

      {/* <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8">
        <button
          className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold py-2 px-6 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2"
          onClick={openModal}
        >
          <span className="text-sm">Send message</span>
        </button>
        <button
          onClick={handleAllMessagesClick}
          className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold py-2 px-6 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2"
        >
          <span className="text-sm">All messages</span>
        </button>
      </div> */}

      {isModalOpen && (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96 relative transition-all duration-500 transform hover:scale-105">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-semibold">Add User Details</h2>
              <button className="text-gray-500 hover:text-gray-700 transition-all duration-300" onClick={closeModal}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="mb-4 flex border-b">
              <button
                className={`py-2 px-4 ${activeTab === "email" ? "border-b-2 border-blue-500" : "text-gray-500"}`}
                onClick={() => setActiveTab("email")}
              >
                Email
              </button>
              <button
                className={`py-2 px-4 ${activeTab === "sms" ? "border-b-2 border-blue-500" : "text-gray-500"}`}
                onClick={() => setActiveTab("sms")}
              >
                SMS
              </button>
            </div>
            {activeTab === "email" ? (
              <form>
                <div className="mb-4">
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                    placeholder="Enter Name"
                  />
                </div>
                <div className="mb-4">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                    placeholder="Enter Email"
                  />
                </div>
                <button type="submit" className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600">
                  Send Message
                </button>
              </form>
            ) : (
              <form>
                <div className="mb-4">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                    Message
                  </label>
                  <textarea
                    id="message"
                    rows="4"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                    placeholder="Enter message"
                  />
                </div>
                <button type="submit" className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600">
                  Send SMS
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
     
  </div>
  )
}

export default Register
